const bcs:any = {
  //auth
  context: {sv:'context',lb:'Context',nm:'ctx',vf:'rid',df:'nam',rf:'ctx'},
  entity:{sv:'entity',lb:'Entity',nm:'eni',vf:'rid',df:'nam',rf:'enm'},
  entitytype:{sv:'entitytype',lb:'EntityType',nm:'eti',vf:'rid',df:'nam',rf:'ety'},
  language:{sv:'language',lb:'Language',nm:'lgi',vf:'rid',df:'nam',rf:'lgn'},
  loginstatus:{sv:'loginstatus',lb:'Login Status',nm:'lsi',vf:'rid',df:'nam',rf:'lsn'},
  loglevel:{sv:'loglevel',lb:'Log Level',nm:'lvi',vf:'rid',df:'nam',rf:'lvn'},
  role:{sv:'role',lb:'Role',nm:'roi',vf:'rid',df:'nam',rf:'rnm'},
  user:{sv:'user',lb:'User',nm:'usi',vf:'rid',df:'nam',rf:'unm'},

  //core basics
  configuration:{sv:'configuration',lb:'Configuration',nm:'cfi',vf:'rid',df:'nam',rf:'cfn'},
  contacttype:{sv:'contacttype',lb:'Type',nm:'cti',vf:'rid',df:'nam',rf:'ctn'},
  country:{sv:'country',lb:'Country',nm:'coi',vf:'rid',df:'nam',rf:'coy'},
  currency:{sv:'currency',lb:'Currency',nm:'cui',vf:'rid',df:'nam',rf:'cur'},
  dashtype:{sv:'dashtype',lb:'Dashtype',nm:'dti',vf:'rid',df:'nam',rf:'dtn'},
  devicetype:{sv:'devicetype',lb:'Device Type',nm:'dti',vf:'rid',df:'nam',rf:'dtn'},
  district:{sv:'district',lb:'District',nm:'dsi',vf:'rid',df:'nam',rf:'dsn'},
  enloc:{sv:'enloc',lb:'Location',nm:'lci',vf:'rid',df:'nam',rf:'lcc'},
  enquirytype:{sv:'enquirytype',lb:'Type',nm:'eti',vf:'rid',df:'nam',rf:'etn'},
  enquirychannel:{sv:'enquirychannel',lb:'Channel',nm:'eci',vf:'rid',df:'nam',rf:'ecn'},
  enquirystate:{sv:'enquirystate',lb:'State',nm:'esi',vf:'rid',df:'nam',rf:'esn'},
  //frequency:{sv:'frequency',lb:'Frequency',nm:'fri',vf:'rid',df:'nam',rf:'frn'},
  gender:{sv:'gender',lb:'Gender',nm:'gdi',vf:'rid',df:'nam',rf:'gdn'},
  idtype:{sv:'idtype',lb:'ID Type',nm:'iti',vf:'rid',df:'nam',rf:'itn'},
  //limit:{sv:'limit',lb:'Limit',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  linker:{sv:'contact',lb:'Linker',nm:'rci',vf:'rid',df:'nam',rf:'rcn'},
  linked:{sv:'contact',lb:'Linked',nm:'dci',vf:'rid',df:'nam',rf:'dcn'},
  linktype:{sv:'linktype',lb:'Type',nm:'lti',vf:'rid',df:'nam',rf:'ltc'},
  location:{sv:'location',lb:'Location',nm:'lci',vf:'rid',df:'nam',rf:'lcn'},
  messagetype:{sv:'messagetype',lb:'Type',nm:'mti',vf:'rid',df:'nam',rf:'mtn'},
  messagemode:{sv:'messagemode',lb:'Mode',nm:'mmi',vf:'rid',df:'nam',rf:'mmn'},
  messagechannel:{sv:'messagechannel',lb:'Channel',nm:'mci',vf:'rid',df:'nam',rf:'mcn'},
  messagestate:{sv:'messagestate',lb:'State',nm:'msi',vf:'rid',df:'nam',rf:'msn'},
  region:{sv:'region',lb:'Region',nm:'rgi',vf:'rid',df:'nam',rf:'rgn'},
  report:{sv:'report',lb:'Report',nm:'rpi',vf:'rid',df:'nam',rf:'rpn'},

  // core main
  connection:{sv:'connection',lb:'connection',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  contact:{sv:'contact',lb:'contact',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  contactlink:{sv:'contactlink',lb:'contactlink',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  dashtab:{sv:'dashtab',lb:'dashtab',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  device:{sv:'device',lb:'device',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  enquiry:{sv:'enquiry',lb:'enquiry',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  entitylocation:{sv:'entitylocation',lb:'entitylocation',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  linkstate:{sv:'linkstate',lb:'linkstate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  linkstatus:{sv:'linkstatus',lb:'linkstatus',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  message:{sv:'message',lb:'message',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  orgtype:{sv:'orgtype',lb:'orgtype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  reportheader:{sv:'reportheader',lb:'reportheader',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  reportsettings:{sv:'reportsettings',lb:'reportsettings',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  reportsummary:{sv:'reportsummary',lb:'reportsummary',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  
  // main basics
  productcategory:{sv:'productcategory',lb:'productcategory',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  stafflevel:{sv:'stafflevel',lb:'stafflevel',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  staffplanstate:{sv:'staffplanstate',lb:'staffplanstate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  staffrole:{sv:'staffrole',lb:'staffrole',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  stafftype:{sv:'stafftype',lb:'stafftype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  unitcat:{sv:'unitcat',lb:'unitcat',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  unitclass:{sv:'unitclass',lb:'unitclass',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  unitgroup:{sv:'unitgroup',lb:'unitgroup',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'}, 
  unittype:{sv:'unittype',lb:'unittype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},

  // main main
  orgunit:{sv:'orgunit',lb:'orgunit',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  product:{sv:'product',lb:'product',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  staff:{sv:'staff',lb:'staff',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  staffplan:{sv:'staffplan',lb:'staffplan',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},

  // finance basics
  accountcat:{sv:'accountcat',lb:'accountcat',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  accounttype:{sv:'accounttype',lb:'accounttype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},

  // finance main
  costcenter:{sv:'costcenter',lb:'costcenter',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  chartofaccounts:{sv:'chartofaccounts',lb:'chartofaccounts',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},

  // budget basics
  budgetcycle:{sv:'budgetcycle',lb:'budgetcycle',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  budgetexecutionstate:{sv:'budgetexecutionstate',lb:'budgetexecutionstate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  budgetexecutiontype:{sv:'budgetexecutiontype',lb:'budgetexecutiontype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  budgetscenario:{sv:'budgetscenario',lb:'budgetscenario',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  budgetstate:{sv:'budgetstate',lb:'budgetstate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  budgettype:{sv:'budgettype',lb:'budgettype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  executionnature:{sv:'executionnature',lb:'executionnature',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  executionsource:{sv:'executionsource',lb:'executionsource',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  executionstate:{sv:'executionstate',lb:'executionstate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  executiontype:{sv:'executiontype',lb:'executiontype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  investmentstate:{sv:'investmentstate',lb:'investmentstate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  investmenttype:{sv:'investmenttype',lb:'investmenttype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  lineitemstate:{sv:'lineitemstate',lb:'lineitemstate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  lineitemtype:{sv:'lineitemtype',lb:'lineitemtype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  transactionstate:{sv:'transactionstate',lb:'transactionstate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  transactiontype:{sv:'transactiontype',lb:'Transaction Type',nm:'xti',vf:'rid',df:'nam',rf:'xtn'},
  
  // budget main
  budgetperiod:{sv:'budgetperiod',lb:'budgetperiod',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  budgetplan:{sv:'budgetplan',lb:'budgetplan',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  investmentproject:{sv:'investmentproject',lb:'investmentproject',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  lineitem:{sv:'lineitem',lb:'lineitem',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  revision:{sv:'revision',lb:'revision',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},

  // forms requisition basics
  itemreviewstate:{sv:'itemreviewstate',lb:'itemreviewstate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  priority:{sv:'priority',lb:'priority',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  requisitionitemstate:{sv:'requisitionitemstate',lb:'requisitionitemstate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  requisitionitemtype:{sv:'requisitionitemtype',lb:'requisitionitemtype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  requisitionstate:{sv:'requisitionstate',lb:'requisitionstate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  requisitiontype:{sv:'requisitiontype',lb:'requisitiontype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  resourcetype:{sv:'resourcetype',lb:'resourcetype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  uom:{sv:'uom',lb:'uom',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},

  // forms requisition main
  requisition:{sv:'requisition',lb:'requisition',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  requisitionitem:{sv:'requisitionitem',lb:'requisitionitem',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},

  // activity basics
  activityoutputstate:{sv:'activityoutputstate',lb:'activityoutputstate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  activityperfstate:{sv:'activityperfstate',lb:'activityperfstate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  activityplanstate:{sv:'activityplanstate',lb:'activityplanstate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  activitystate:{sv:'activitystate',lb:'Activity State',nm:'asi',vf:'rid',df:'nam',rf:'asn'},
  activitytype:{sv:'activitytype',lb:'Activity Type',nm:'ati',vf:'rid',df:'nam',rf:'atn'},
  
  // activity main
  activity:{sv:'activity',lb:'Activity',nm:'aci',vf:'rid',df:'nam',rf:'acn'},
  activityoutput:{sv:'activityoutput',lb:'activityoutput',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  activityplan:{sv:'activityplan',lb:'activityplan',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  driver:{sv:'driver',lb:'driver',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},

  // kpis basics
  axis:{sv:'axis',lb:'axis',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  kpifrequency:{sv:'kpifrequency',lb:'kpifrequency',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  kpiperfstate:{sv:'kpiperfstate',lb:'kpiperfstate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  kpiplanstate:{sv:'kpiplanstate',lb:'kpiplanstate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  kpiplantype:{sv:'kpiplantype',lb:'kpiplantype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  kpistate:{sv:'kpistate',lb:'kpistate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  kpitype:{sv:'kpitype',lb:'kpitype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  objectivestate:{sv:'objectivestate',lb:'objectivestate',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  objectivetype:{sv:'objectivetype',lb:'objectivetype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},

  // kpis main
  kpimaster:{sv:'kpimaster',lb:'kpimaster',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  kpiplan:{sv:'kpiplan',lb:'kpiplan',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  objective:{sv:'objective',lb:'objective',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},

  // files
  filegroup:{sv:'filegroup',lb:'Group',nm:'gpi',vf:'rid',df:'nam',rf:'gpn'},

  // files main
  file:{sv:'file',lb:'file',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  form:{sv:'form',lb:'form',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},

  // apis basics
  apiaccounttype:{sv:'apiaccounttype',lb:'apiaccounttype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  apitype:{sv:'apitype',lb:'apitype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  apichannel:{sv:'apichannel',lb:'apichannel',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  apiprovidertype:{sv:'apiprovidertype',lb:'apiprovidertype',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},

  // apis main
  apiaccount:{sv:'apiaccount',lb:'apiaccount',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  apimaster:{sv:'apimaster',lb:'apimaster',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},
  apiprovider:{sv:'apiprovider',lb:'apiprovider',nm:'lmi',vf:'rid',df:'nam',rf:'lmn'},

  // uiux
  uidoc:{sv:'uidoc',lb:'UI Document',nm:'dci',vf:'rid',df:'nam',rf:'dcn'},
  uipage:{sv:'uipage',lb:'UI Page',nm:'pgi',vf:'rid',df:'nam',rf:'pgn'},
  uisection:{sv:'uisection',lb:'UI Section',nm:'sci',vf:'rid',df:'nam',rf:'scn'},
  uidevice:{sv:'uidevice',lb:'UI Device',nm:'dvi',vf:'rid',df:'nam',rf:'dvn'},
  uilang:{sv:'uilang',lb:'UI Language',nm:'lgi',vf:'rid',df:'nam',rf:'lgn'},

};

// const servicelist:any = [
//   ['idv','ID Verification'],
//   ['idv-poa','ID+POA Verification'],
//   ['facematch','Liveness+Facematch'],
//   ['facematch-id','Liveness+Facematch+ID'],
//   ['facematch-id-poa','Liveness+Facematch+ID+POA'],
//   ['videomatch','Videomatch'],
//   ['photomatch','Photomatch'],
//   ['regmatch','Regmatch']
// ];

const lcs:any = {
  branch: { lb: 'Branch', nm: 'bri', vf: 'rid', df: 'nam', et: 'Select', sd: [['0', 'Default']] },
  context: { lb: 'Context', nm: 'ctx', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Default'], [2, 'Ordering'], [4, 'Production'], [8, 'Distribution'], [16, 'Installation'], [32, 'Maintenance']] },
  credit: { lb: 'Credit', nm: 'cre', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, '1 HR'], [2, '2 HRS'], [3, '3 HRS'], [4, '4 HRS'], [5, '5 HR'], [6, '6 HRS'], [7, '7 HRS'], [8, '8 HRS']] },
  country: { lb: 'Country', nm: 'coi', vf: 'rid', df: 'nam', et: 'Select', sd: [['1', 'Ghana'], ['2', 'Nigeria'], ['3', "Cote D'Ivoire"]] },
  format: { lb: 'Format', nm: 'fmt', vf: 'rid', df: 'nam', et: 'Select', sd: [['pdf', 'Portable Document(PDF)'], ['csv', 'Comma Separated(CSV)']] },
  gender: { lb: 'Gender', nm: 'gdi', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Male'], [0, 'Female']] },
  regstatus: { lb: 'Registration', nm: 'rst', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Registered'], [0, 'Unregistered']] },
  reporttype: { lb: 'Report Type', nm: 'rpt', vf: 'rid', df: 'nam', et: 'Select', sd: [['sum', 'Summary'], ['det', 'Detail']] },
  //service: { lb: 'Service', nm: 'svc', vf: 'rid', df: 'nam', et: 'Select', sd: servicelist },
  status: { lb: 'Status', nm: 'sts', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Enabled'], [0, 'Disabled'], [2, 'Locked']] },
  title: { lb: 'Title', nm: 'tti', vf: 'rid', df: 'nam', et: 'Select', sd: [[3, 'Dr.'], [2, 'Mrs.'], [1, 'Mr.'], [0, 'Miss']] },
  sector: { lb: 'Sector', nm: 'sci', vf: 'rid', df: 'nam', et: 'Select', sd: [['0', 'Default']] },
};

function basic(service:string){
  return bcs[service];
}

function local(service:string){
  return lcs[service];
}

function combo(service:string){
  return bcs[service] || lcs[service];
}

function combox(type:string,service:string){
  return {bcs,lcs}[type][service];
}

export {bcs, lcs, basic, local, combo};
export default combox;
